var getFullTitle = function getFullTitle(product) {
  var reference = (product == null ? void 0 : product.reference) ? " - ".concat(product == null ? void 0 : product.reference) : '';
  return "".concat(product == null ? void 0 : product.title).concat(reference).replace(/\s\s+/g, ' ').trim();
};
export default getFullTitle;